import React from "react";
import { store } from "../../redux/storeConfig/store";
import { addFollowupProgramModal } from "../../redux/actions/sidebar/sidebarAction";

export const StepButton = ({ edit }) => {
  return (
    <div className="action-wrapper blk-padding-y">
      <div className="action-inner-block">
        <div className="action-btn-block">
          <button
            className="btn btn-medium btn-transparent"
            onClick={() => {
              store.dispatch(addFollowupProgramModal(false));
            }}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="btn btn-medium"
          >
            {edit ? "Update Program" : "Save Program"}
          </button>
        </div>
      </div>
    </div>
  );
};